// This is bit confusing, but we're typing this manually so we get some sort of typechecking,
// while still being flexible enough so we can call this from anywhere, without having to get all possible module types

type IsBreakingNewsInput = {
	breakingnewsEnd?: string | null | undefined;
};

export function articleIsBreakingNews({ breakingnewsEnd }: IsBreakingNewsInput, now: Date) {
	if (breakingnewsEnd && now <= new Date(breakingnewsEnd)) {
		return true;
	}

	return false;
}
